export const esTelemedicina = (valor) =>
  valor === true ||
  valor === 1 ||
  valor === "1" ||
  (typeof valor === "string" && valor.toLowerCase() === "true");
